export default __webpack_public_path__ + "static/media/profile.6cce11e9.jpg";